<template>
  <v-container>
    <v-row v-if="isDesktop">
      <v-col cols="12">
        <panel-title icon="mdi-email-multiple" :title="$t('TOPLUMAIL.TITLE')" :desc="$t('TOPLUMAIL.SUB_TITLE')" />
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between py-0">
        <div>
          <v-btn color="blue" dark class="text-subtitle-2 rounded-lg" :loading="editorStatus">
            <v-icon left>mdi-send</v-icon>
            {{ $t("TOPLUMAIL.SEND_BTN") }}
          </v-btn>
        </div>
        <div>
          <v-btn @click="saveDesignDialog" dark color="deep-purple" class="text-subtitle-2 mr-3 rounded-lg" :loading="editorStatus">
            <v-icon left>mdi-content-save</v-icon>
            {{ $t("TOPLUMAIL.SAVE_DESING_BTN") }}
          </v-btn>
          <v-btn @click="tasarimListDialog" dark color="deep-purple" class="text-subtitle-2 mr-3 rounded-lg" :loading="editorStatus">
            <v-icon left>mdi-pencil-ruler</v-icon>
            {{ $t("TOPLUMAIL.DESING_LIST_BTN") }}
          </v-btn>
          <v-btn @click="exportHtml" dark color="indigo" class="text-subtitle-2 rounded-lg" :loading="editorStatus || exportLoading">
            <v-icon left>mdi-application-export</v-icon>
            {{ $t("TOPLUMAIL.EXPORT_BTN") }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-2 py-0">
        <div class="d-flex align-center text-subtitle-2 font-weight-regular">
          <v-icon size="18" class="mr-1">mdi-information</v-icon>
          <span>{{ $t("TOPLUMAIL.INFORMATION") }}</span>
        </div>
      </v-col>
      <v-col cols="12" class="pt-2">
        <div id="mail-editor-app" class="elevation-2 rounded-lg overflow-hidden">
          <div id="emailEditor"></div>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <panel-title icon="mdi-email-multiple" :title="$t('TOPLUMAIL.TITLE')" :desc="$t('TOPLUMAIL.SUB_TITLE')" />
      </v-col>
      <v-col cols="12" class="d-flex">
        <v-alert type="warning">
          {{ $t("TOPLUMAIL.IS_DESKTOP_WARNING") }}
        </v-alert>
      </v-col>
    </v-row>

    <v-dialog v-model="mediaModal">
      <media-explorer v-model="mediaModal" @selected="getImage" format="images" :list-selection="false" :close-selection="true" />
    </v-dialog>

    <!--  Save Design Dialog  -->
    <v-dialog v-model="saveDesignData.dialog" max-width="500">
      <v-card>
        <v-card-title class="text-body-1 blue--text">
          <v-icon left color="blue">mdi-image-edit</v-icon>
          {{ $t("TOPLUMAIL.SAVE_DESIGN_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            prepend-inner-icon="mdi-image-frame"
            :label="$t('TOPLUMAIL.SAVE_DESIGN_DIALOG.DESIGN_NAME_LABEL')"
            persistent-hint
            :hint="$t('TOPLUMAIL.SAVE_DESIGN_DIALOG.DESIGN_NAME_HINT')"
            v-model="saveDesignData.name"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="saveDesignData.dialog = false">
            {{ $t("TOPLUMAIL.SAVE_DESIGN_DIALOG.CLOSE_BTN") }}
          </v-btn>
          <v-btn color="blue darken-1" dark :loading="saveDesignData.loading" @click="saveDesign()">
            {{ $t("TOPLUMAIL.SAVE_DESIGN_DIALOG.SAVE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Save Design Dialog  -->

    <!--  Design List Dialog  -->
    <v-dialog v-model="tasarimListData.dialog" max-width="900">
      <v-card>
        <v-card-title class="text-body-1 deep-purple--text">
          <v-icon left color="deep-purple">mdi-image-edit</v-icon>
          {{ $t("TOPLUMAIL.DESIGN_LIST_DIALOG.TITLE") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-2 pb-2">
          <v-list v-if="tasarimListData.list.length > 0">
            <v-list-item :key="key" v-for="(item, key) in tasarimListData.list" class="grey lighten-3 rounded-lg mb-2 d-flex align-center">
              <v-list-item-content>
                <v-list-item-title class="text-body-2">
                  <v-icon size="18" color="deep-purple darken-2" left>mdi-pencil-ruler</v-icon>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <div>
                  <v-btn dark small color="red" class="mr-1" text @click="removeDesignDialog(item.code)">
                    <v-icon size="20">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn dark small color="deep-purple" @click="loadDesign(item.code)">
                    <v-icon left size="20">mdi-upload</v-icon>
                    {{ $t("TOPLUMAIL.DESIGN_LIST_DIALOG.IMPORT_BTN") }}
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <p
            v-else-if="!tasarimListData.loading"
            class="text-body-2 d-flex justify-center align-center my-0 py-4 rounded-md grey lighten-3 font-weight-medium grey--text text--darken-1"
          >
            {{ $t("TOPLUMAIL.DESIGN_LIST_DIALOG.NO_DESIGNS_FOUND") }}
          </p>
          <div v-else class="d-flex justify-center align-center flex-column mt-5 mb-1">
            <v-progress-circular indeterminate color="deep-purple" class="mb-2" size="45"></v-progress-circular>
            <span class="deep-purple--text text--darken-4">{{ $t("TOPLUMAIL.DESIGN_LIST_DIALOG.LOADING_DESIGNS") }}</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="tasarimListData.dialog = false">
            <v-icon size="20" class="mr-1">mdi-close</v-icon>
            {{ $t("TOPLUMAIL.DESIGN_LIST_DIALOG.CLOSE_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Design List Dialog  -->

    <!--  Remove Design Dialog  -->
    <v-dialog v-model="removeDesignData.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("TOPLUMAIL.DELETE_DESIGN_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("TOPLUMAIL.DELETE_DESIGN_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="removeDesignData.dialog = false">
            {{ $t("TOPLUMAIL.DELETE_DESIGN_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="removeDesignData.loading" @click="removeDesign()">
            {{ $t("TOPLUMAIL.DELETE_DESIGN_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Remove Design Dialog  -->
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";
import MediaExplorer from "../../../components/Settings/Media/MediaExplorer.vue";
import { loadScript } from "./EmailScriptLoader.js";
import TopluMailService from "@/services/TopluMailService";
import { mapState } from "vuex";

export default {
  components: { PanelTitle, MediaExplorer },
  name: "TopluMailEditor",
  data() {
    return {
      minHeight: "1000px",
      displayMode: "email",
      projectId: 0, // replace with your project id
      tools: {},
      options: {},
      appearance: {
        theme: "light",
        panels: {
          tools: {
            dock: "right"
          }
        }
      },
      mediaModal: false,
      imageDone: "",
      editor: {},
      editorStatus: true,
      saveDesignData: {
        dialog: false,
        name: ""
      },
      tasarimListData: {
        dialog: false,
        list: []
      },
      removeDesignData: {
        dialog: false,
        code: 0,
        loading: false
      },
      exportLoading: false
    };
  },
  computed: {
    ...mapState({
      apiLanguage: state => state.Language.apiLanguage
    }),
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    }
  },
  mounted() {
    loadScript(this.loadEditor.bind(this));
  },
  methods: {
    getImage(img) {
      if (img) {
        this.imageDone = `${this.$ApiUrl}images/${img.name}`;
      }
    },
    loadEditor() {
      unlayer;
      const options = this.options || {};
      if (this.projectId) {
        options.projectId = this.projectId;
      }
      if (this.tools) {
        options.tools = this.tools;
      }
      if (this.appearance) {
        options.appearance = this.appearance;
      }
      if (this.apiLanguage) {
        options.locale = this.apiLanguage;
      }

      this.editor = unlayer.init({
        ...options,
        id: "emailEditor",
        displayMode: "email",
        source: {
          name: "api-mail-editor",
          version: "1"
        }
      });

      let self = this;
      unlayer.registerCallback("selectImage", function(data, done) {
        // Open the modal
        self.mediaModal = true;
        self.$watch(
          vm => vm.mediaModal,
          val => {
            if (!val && self.imageDone) {
              done({ url: self.imageDone });
              self.imageDone = "";
            }
          }
        );
      });

      unlayer.addEventListener("design:loaded", function() {
        self.editorStatus = false;
      });
    },
    editorLoaded(editor) {
      // Pass your template JSON here
      // this.$refs.emailEditor.editor.loadDesign({});
    },
    loadDesign(tasarimCode) {
      TopluMailService.tasarimDetay({ tasarimCode }).then(res => {
        if (res.status === 200) {
          let designData = JSON.parse(res.data.data);
          unlayer.loadDesign(designData);
          this.$snotify.success(this.$t("TOPLUMAIL.NOTIFY.DESIGN_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.tasarimListData.dialog = false;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    saveDesign() {
      const tasarimAdi = this.saveDesignData.name;
      unlayer.saveDesign(design => {
        const tasarimData = JSON.stringify(design);
        TopluMailService.tasarimEkle({ tasarimAdi, tasarimData }).then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("TOPLUMAIL.NOTIFY.DESIGN_SAVE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.saveDesignData.dialog = false;
            this.saveDesignData.name = "";
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
      });
    },
    saveDesignDialog() {
      this.saveDesignData.dialog = true;
    },
    tasarimListDialog() {
      this.tasarimListData.dialog = true;
      this.tasarimListData.loading = true;
      this.tasarimListesi();
    },
    tasarimListesi() {
      return TopluMailService.tasarimListesi()
        .then(res => {
          this.tasarimListData.list = res.data;
        })
        .then(() => {
          this.tasarimListData.loading = false;
        });
    },
    removeDesign() {
      const tasarimCode = this.removeDesignData.code;
      this.removeDesignData.loading = true;
      TopluMailService.tasarimiKaldir({ tasarimCode })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("TOPLUMAIL.NOTIFY.DESIGN_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.tasarimListData.list = this.tasarimListData.list.filter(t => t.code !== tasarimCode);
            return (this.removeDesignData.dialog = false);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.removeDesignData.loading = false;
        });
    },
    removeDesignDialog(tasarimCode) {
      this.removeDesignData.code = tasarimCode;
      this.removeDesignData.dialog = true;
    },
    exportHtml() {
      this.exportLoading = true;
      unlayer.exportHtml(data => {
        console.log("exportHtml", data);
        this.downloadBlobAsFile(
          new Blob([data.html], {
            type: "text/html"
          }),
          `${this.$t("TOPLUMAIL.SAVE_FILE_AS_HTML_TEXT")}.html`
        );
      });
    },
    downloadBlobAsFile(blob, filename) {
      const a = document.createElement("a"),
        object_URL = URL.createObjectURL(blob);

      a.href = object_URL;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(object_URL);
      this.exportLoading = false;
    }
  }
};
</script>

<style>
#emailEditor {
  flex: 1;
  display: flex;
  height: 1000px;
}
</style>
